<template>
  <TransitionRoot
    as="template"
    :show="isOpen"
  >
    <Dialog
      as="div"
      class="fixed z-40 inset-0 overflow-y-auto"
      @close="$emit('close')"
    >
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 dialog-overlay" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="transform inline-block align-bottom bg-gray-100 rounded-[10px] text-left shadow-dialog transition-all sm:my-8 w-full sm:align-middle max-w-sm sm:w-full pb-6"
          >
            <div class="absolute -top-16 -right-2 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
              <button
                @click="$emit('close')"
                type="button"
                class="bg-gray-100 p-1 rounded-[10px] text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-100"
              >
                <span class="sr-only">Close panel</span>
                <XIcon
                  class="h-5 w-5"
                  aria-hidden="true"
                />
              </button>
            </div>
            <div>
              <div>
                <DialogTitle
                  as="h3"
                  class="py-5 px-7 text-gray-900 text-lg leading-6 font-semibold rounded-t-[10px]"
                  :class="[headerBgColor, headerTextColor]"
                  v-if="$slots.header"
                >
                  <slot name="header" />
                </DialogTitle>

                <div class="px-6 py-3">
                  <slot></slot>
                </div>
              </div>
            </div>
            <div
              class="py-4 px-6 border-t border-gray-400 -mb-6 mt-4"
              v-if="$slots.footer"
            >
              <slot name="footer" />
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped>
.dialog-overlay {
  background: rgba(186, 186, 186, 0.25);
}
</style>

<script setup>
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon, ExclamationIcon, XIcon } from '@heroicons/vue/outline'
import { computed } from 'vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    validator(value, props) {
      // The value must match one of these strings
      return ['info', 'danger'].includes(value)
    },
    required: false,
    default: 'info'
  }
})

const headerBgColor = computed(() => {
  const colors = {
    info: 'bg-blue-200',
    danger: 'bg-red-200'
  }

  return colors[props.type]
})
const headerTextColor = computed(() => {
  const colors = {
    info: 'text-blue-600',
    danger: 'text-red-600'
  }

  return colors[props.type]
})
</script>
